import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../../../store";
import { toast } from "react-toastify";
import { setSelectedFilters } from "../../bloc/collectionsSlice";


const useCollectionFilter = () => {


    const paymentModes = ['All', 'IMPS', 'NEFT', 'RTGS'];

    // const statuses = ['All', 'Success', 'BEN_SUCCESS', 'BEN_FAILURE'];
    const statusMap: Record<string, string> = {
        SUCCESS: "Success",
        BEN_SUCCESS: "Validated",
        BEN_FAILURE: "Validation Failed",
    };

    const statuses = ["All", ...Object.values(statusMap)];

    const labelToBackendMap: Record<string, string> = Object.fromEntries(
        Object.entries(statusMap).map(([k, v]) => [v, k])
    );

    const [selectedModes, setSelectedModes] = useState<string[]>([]);
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>(['SUCCESS']);
    const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);

    const dispatch = useDispatch();

    const {
        filters,
        customers,
    } = useSelector((state: TRootState) => ({
        filters: state.collections.filters,
        customers: state.collections.customers,
    }));

    const customerOptions = customers?.map((customer) => ({
        id: customer.benCode,
        label: customer.customerName,
        value: customer.benCode,
        mobile: "",
        type: "VA ID",
        profilePic: "",
        address: "",
    }));

    useEffect(() => {
        setSelectedModes(filters.selectedModes);
        setSelectedStatuses(filters.selectedStatuses.length ? filters.selectedStatuses : ['SUCCESS']);
        setSelectedCustomers(filters.selectedCustomers);
    }, []);

    const onSelectMode = (type: string) => {
        if (type == 'All') {
            let updatedTypes = selectedModes.includes(type)
                ? []
                : [...paymentModes];
            setSelectedModes(updatedTypes);
        } else {
            let updatedTypes = selectedModes.includes(type)
                ? selectedModes.filter((t) => t !== type && t !== 'All')
                : [...selectedModes, type];
            if (updatedTypes.length == paymentModes.length - 1) {
                updatedTypes = [...updatedTypes, 'All'];
            }
            setSelectedModes(updatedTypes);
        }
    }

    const onResetType = () => {
        setSelectedModes([]);
    }

    const onSelectStatus = (label: string) => {
        if (label === "All") {
            setSelectedStatuses(selectedStatuses.includes("All") ? [] : Object.keys(statusMap));
            return;
        }

        const backendCode = labelToBackendMap[label];

        let updatedStatuses = selectedStatuses.includes(backendCode)
            ? selectedStatuses.filter((s) => s !== backendCode)
            : [...selectedStatuses, backendCode];

        if (updatedStatuses.length === Object.keys(statusMap).length) {
            updatedStatuses.push("All");
        }

        setSelectedStatuses(updatedStatuses);
    };

    const onResetStatus = () => {
        setSelectedStatuses(['SUCCESS']);
    }

    const onSeletCustomer = (customers: any) => {
        setSelectedCustomers(customers.map((c: any) => c.value));
    }

    const onResetCustomers = () => {
        setSelectedCustomers([]);
    }

    const onApply = () => {
        dispatch(
            setSelectedFilters({
                selectedModes: selectedModes,
                selectedStatuses: selectedStatuses,
                selectedCustomers: selectedCustomers,
            }),
        );
    }

    const onReset = () => {
        setSelectedModes([]);
        setSelectedStatuses(['SUCCESS']);
        setSelectedCustomers([]);
        dispatch(
            setSelectedFilters({
                selectedModes: [],
                selectedStatuses: ['SUCCESS'],
                selectedCustomers: [],
            }),
        );
        toast.success('Filters reset successfully');
    }

    const isFilterApplied = () => {
        return filters.selectedModes.length > 0 || filters.selectedStatuses.length > 0 || filters.selectedCustomers.length > 0;
    }

    return {
        paymentModes,
        statuses,
        selectedModes,
        selectedStatuses,
        onSelectMode,
        onResetType,
        onSelectStatus,
        onResetStatus,
        onApply,
        onReset,
        isFilterApplied,
        onSeletCustomer,
        customers,
        selectedCustomers,
        customerOptions,
        onResetCustomers,
        labelToBackendMap,
        statusMap,
    };
}

export default useCollectionFilter;